import React from 'react';

/**
 * Station Tickets
 * @returns
 */
function StationTickets() {
  return <div>StationTickets</div>;
}

export default StationTickets;
